import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {Structure} from '@docma-mm-core/structure/structure';
import {AppContainerService} from '@mydocma/app-container';
import {BehaviorSubject, Subject} from 'rxjs';
import {distinctUntilChanged, filter, map, switchMap, tap} from 'rxjs/operators';
import {MmProjectLoaderService} from '../../../mm-project/mm-project-loader.service';
import {MmProjectService} from '../../../mm-project/mm-project.service';
import {MmViewService} from '../../../mm-view.service';
import {MmFilterService} from '../../mm-filter.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {MmFilterModel} from '../../mm-filter.model';
import {MmStructureTreeComponent} from '../mm-structure-tree/mm-structure-tree.component';

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-mm-structure-left-pane',
  templateUrl: './mm-structure-left-pane.component.html',
  styleUrls: ['./mm-structure-left-pane.component.scss']
})
export class MmStructureLeftPaneComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('structureTree') structureTreeComponent?: MmStructureTreeComponent;

  public loading$ = new BehaviorSubject<boolean>(false);


  strcutures$ = this.mmViewService.currentProject$.pipe(
    tap(p => p !?? this.mmViewService.closeFilter()),
    tap(p => this.loading$.next(true)),
    switchMap(p => this.loaderService.structures.pipe(filter(s => s?.loadState?.status === LoadStatusEnum.Loaded && s?.data?.length > 0),
                      switchMap(structures => this.mmFilterService.state.pipe(map(state => ({structures, state}))))
    )),
    tap(p => this.loading$.next(false)),
    switchMap(param => this.appContainerService.activeContentButton.pipe(filter(b => b?.id === 'filter-str'),
      map(b => param.structures.data),
      tap(ss => {
        console.debug('MmStructureLeftPaneComponent: Setting structures. Count: ', ss);
      })
    )),
    untilDestroyed(this),
    distinctUntilChanged()
  );

  stateSubject = new Subject<MmFilterModel>();
  state$ = this.stateSubject.asObservable();


  constructor(private readonly mmViewService: MmViewService,
              private readonly mmFilterService: MmFilterService,
              private readonly projectService: MmProjectService,
              public readonly appContainerService: AppContainerService,
              private readonly loaderService: MmProjectLoaderService) {

    this.projectService.loadingState
    .pipe(untilDestroyed(this))
    .subscribe(l => this.loading$.next(l));
  }

  ngOnDestroy(): void {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.mmFilterService.state
      .pipe(untilDestroyed(this), switchMap(s => this.appContainerService.activeContentButton
        .pipe(filter(b => b?.id === 'filter-str'),
          map(b => {
            return s;
          })
        )
      ), distinctUntilChanged()).subscribe(s => {
      console.debug('state$ #2', s);
      if (s.structure) {
        setTimeout(() => {
          this.structureTreeComponent.treeService.selectNode(s.structure.Id.toString());
        }, 100)
      }
    });
  }

  onCloseClick() {
    this.mmViewService.closeFilter();
  }

  onStructureClick(structure: Structure) {
    this.mmFilterService.setStructure(structure);
  }


}
